import React from 'react';
import loginIcon from '../../../../../../assets/loginIcon.png';
import './styles.scss';

const LoginSection = () => {
  const handleLoginClick = () => {
    document.getElementById('loginTrigger').click();
  };

  return (
    <div className="loginStripSection">
      <span className="loginStripIcon">
        <span className="loginIcon" style={{ backgroundImage: `url(${loginIcon})` }} />
      </span>
      <span className="stripDetails">
        Enjoy special features like{' '}
        <span className="highlitedText">lock-fares, pay-later, unique deals & much more.</span>
      </span>
      <span onClick={handleLoginClick} className="loginNowLink">
        Login Now
      </span>
    </div>
  );
};

export default LoginSection;
